import { getMyRentList, setMyRentList } from '@/utils/storage'
export default {
  namespaced: true,
  state () {
    return {
      // 个人商品列表
      myRentsList: getMyRentList()
    }
  },
  getters: {

  },
  mutations: {
    setMyRentList (state, obj) {
      state.myRentsList = obj
      setMyRentList(obj)
    }
  },
  actions: {
  }
}
